import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { Category } from '@ilteducation/content-ref-data-types';
import { getAllRefData } from '@/data-provider/refDataProvider';
import IdIcon from '@/components/IdIcon.vue';
import DownloadVideoStats from '@/components/videos/DownloadVideoStats.vue';
import { getTitle } from '@/foundations/helpers/videoUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



const availableCategories = ref<Category[]>([]);
getAllRefData('categories').then((categories) => {
  availableCategories.value = categories;
});

const getSubjectById = (id: string) => availableCategories.value.find((s) => s.id === id);

const fields = [
  {
    source: 'title',
    label: 'Title',
    sortable: true,
  },
  {
    label: 'Subjects',
    type: 'reference-array',
    source: 'categories',
    itemText: 'category',
    attributes: {
      reference: 'categories',
      color: (id: string) => getSubjectById(id)?.color,
    },
  },
  {
    source: 'filmId',
    label: 'Internal Film ID',
    sortable: true,
  },
  { source: 'availabilityRealms', label: 'Active' },
];

const filters = [
  {
    source: 'filmId',
    label: 'Internal Film ID',
    alwaysOn: true,
    type: 'text',
  },
  {
    source: 'state',
    label: 'State',
    alwaysOn: true,
    type: 'select',
    attributes: {
      multiple: false,
      choices: ['published', 'processing', 'disabled', 'new'],
    },
  },
  {
    source: 'legacyIntroFilmsUids.fi.uid',
    label: 'FI: Intro-films UID',
    alwaysOn: false,
  },
  {
    source: 'legacyIntroFilmsUids.no.uid',
    label: 'NO: Intro-films UID',
    alwaysOn: false,
  },
  {
    source: 'legacyIntroFilmsUids.se.uid',
    label: 'SE: Intro-films UID',
    alwaysOn: false,
  },
];

return { __sfc: true,availableCategories, getSubjectById, fields, filters, IdIcon, DownloadVideoStats, getTitle }
}

})